/// <reference types="@angular/localize" />

import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {environment} from './environments/environment';
import {loadGoogleMaps} from './app/shared/services/google-maps-loader';

loadGoogleMaps(environment.googleMapsApiKey)
	.catch(() => undefined)
	.then(() => bootstrapApplication(AppComponent, appConfig))
	.catch((err) => console.error(err));
